((d, w) => {
	const latestJobsFlexBlock = d.querySelector("#flex-latest-jobs-form");
	console.log("script");
	if (latestJobsFlexBlock) {
		const select = latestJobsFlexBlock.querySelector("select");
		console.log("block");

		select.addEventListener("change", () => {
			console.log("change");
			latestJobsFlexBlock.submit();
		});
	}
})(document, window);
